import { useMutation, useQueryClient } from "@tanstack/react-query";
import { stockApi } from "@/lib/stock.api";
import { queryKeys } from "@/lib/query-keys";

export function useRejectStockEditRequestMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ requestId, note }: { requestId: number; note?: string }) =>
      stockApi.rejectEditRequest(requestId, note),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.stockEditRequests() });
    },
  });
}
